import { Navigate, useParams } from "react-router-dom";
import { urls } from "../../../urls";

export const LegacyEventEditLinkRedirect = () => {
  const { eventId } = useParams();

  if (!eventId) return <Navigate to={urls.app.sourcingEvents.viewAll} replace />;

  return <Navigate to={urls.app.sourcingEvents.edit.go(eventId).info} replace />;
};
